// extracted by mini-css-extract-plugin
module.exports = {"g":"block-g_g__2zMng","flex":"block-g_flex__1-rmL"};